import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    QueryDropdown,
    BaasicButton,
} from "core/components";
import EmptyIcon from "themes/assets/img/building-modern.svg";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";

function TeamsListTemplate({ teamsListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization,
        userStore,
        routes,
        isAdmin,
        filterOnChange,
    } = teamsListViewStore;
    return (
        <ApplicationListLayout store={teamsListViewStore}>
            <PageNavigation>
                {isAdmin && (
                    <BaasicButton
                        className="btn btn--base btn--primary"
                        label={"LIST_LAYOUT.CREATE_BUTTON"}
                        onClick={() => routes.create()}
                    ></BaasicButton>
                )}
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()}>
                <div className="u-mar--bottom--sml">
                    <div className="u-mar--bottom--sml">
                        <TableFilter
                            queryUtility={queryUtility}
                            filterVisible={true}
                        >
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                                <QueryDropdown
                                    queryUtility={queryUtility}
                                    store={userStore}
                                    propertyName="userId"
                                    label="User"
                                    onChange={filterOnChange}
                                />
                            </div>
                        </TableFilter>
                    </div>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
}

function renderEmpty() {
    return (
        <EmptyState
            image={EmptyIcon}
            title="ROLE.LIST.EMPTY_STATE.TITLE"
            description="ROLE.LIST.EMPTY_STATE.DESCRIPTION"
        />
    );
}

TeamsListTemplate.propTypes = {
    teamsListViewStore: PropTypes.object,
};

export default defaultTemplate(TeamsListTemplate);
